export default function Kebijakan() {
  return (
    <div className="flex w-full flex-col gap-4">
      <div className="mx-auto flex flex-col px-1 lg:px-5">
        <div className="flex flex-col items-center justify-center gap-2 py-8">
          <p className="font-nunito font-bold text-xl lg:text-2xl">Kebijakan Privasi</p>
          <div className="flex flex-col gap-6 py-5 text-left font-nunito font-semibold lg:font-normal">
            <ol className="flex flex-col gap-5 text-sm lg:text-lg">
              <li>
                <p>Pendahuluan</p>
                <ol>
                  <li className="text-justify">
                    Selamat datang di Wardaya Online (wardayaonline.com).
                    Wardaya Online merupakan platform pembelajaran online yang
                    dimiliki dan dikelola oleh Wardaya College. Wardaya College
                    berkomitmen menjalankan tanggung jawabnya berdasarkan
                    undang-undang dan peraturan privasi yang berlaku untuk
                    menghormati serta melindungi privasi hak dan kepentingan
                    semua pengguna situs Wardaya Online. Kami menyadari
                    pentingnya data pribadi dan kepercayaan yang Anda berikan,
                    karena itu kami bertanggung jawab penuh untuk mengelola,
                    melindungi, dan memproses data pribadi Anda dengan baik.
                    Kebijakan privasi ini dirancang untuk membantu Anda memahami
                    bagaimana Kami mengumpulkan, menggunakan, mengungkapkan,
                    dan/atau memproses data pribadi Anda, baik saat ini atau di
                    masa depan. Selain itu, Kebijakan Privasi dapat membantu
                    Anda membuat keputusan sebelum memberikan data pribadi Anda
                    melalui platform ini. Harap membaca Kebijakan Privasi ini
                    dengan dengan cermat sebelum Anda mulai menggunakan platform
                    Kami. Jika Anda memiliki pertanyaan terkait informasi atau
                    praktik privasi Kami, Anda dapat menghubungi kami.
                  </li>
                  <li className="text-justify">
                    “Data Pribadi” berarti data, baik benar maupun tidak,
                    tentang individu yang dapat diidentifikasi dari data
                    tersebut, atau dari data lainnya. Informasi yang dimiliki
                    atau kemungkinan besar dapat diakses oleh organisasi. Contoh
                    umum data pribadi dapat mencangkup nama, nomor identifikasi,
                    dan kontak informasi.
                  </li>
                  <li className="text-justify">
                    Dengan menggunakan layanan, mendaftar akun, mengunjungi
                    situs web, atau mengakses layanan Kami lainnya, Anda
                    mengakui dan setuju bahwa Anda menerima praktik,
                    persyaratan, dan/atau kebijakan yang telah diuraikan dalam
                    Kebijakan Privasi. Dengan ini, Anda menyetujui Kami untuk
                    mengumpulkan, menggunakan, mengungkapkan, dan/atau memproses
                    data pribadi Anda seperti yang dijelaskan dalam Kebijakan
                    Privasi.{" "}
                    <span className="font-bold">
                      JIKA ANDA TIDAK MENYETUJUI PENGOLAHAN DATA PRIBADI ANDA
                      SEBAGAIMANA DIJELASKAN DALAM KEBIJAKAN PRIVASI, ANDA TIDAK
                      DAPAT MENGGUNAKAN LAYANAN ATAU MENGAKSES SITUS WEB KAMI.
                    </span>{" "}
                    Jika ada perubahan pada Kebijakan Privasi, Kami akan
                    mengunggah perubahan tersebut dan memberikan pengumuman
                    melalui situs web Kami.
                  </li>
                </ol>
              </li>
              <li>
                <p>Penggunaan Data Pribadi Pengguna</p>
                <ol>
                  <li>Kami akan menggunakan dan/atau mengolah informasi :</li>
                  <ol className="">
                    <li className="text-justify">
                      Saat Anda mendaftar dan/atau menggunakan layanan atau
                      situs Kami, termasuk membuka akun di platform Kami;
                    </li>
                    <li className="text-justify">
                      Saat Anda mengirimkan data formulir, termasuk namun tidak
                      terbatas pada formulir aplikasi atau formulir lain yang
                      berkaitan dengan produk dan layanan Kami, baik dalam
                      bentuk fisik atau online atau fisik;
                    </li>
                    <li className="text-justify">
                      Saat Anda membuat perjanjian atau memberikan dokumentasi
                      dan informasi lain—sehubungan dengan interaksi Anda dengan
                      Kami atau saat Anda menggunakan produk dan layanan Kami;
                    </li>
                    <li className="text-justify">
                      Saat Anda berinteraksi dengan Kami, seperti melalui
                      panggilan telepon (yang mungkin direkam), surat, faks,
                      pertemuan tatap muka, platform media sosial, dan email;
                    </li>
                    <li className="text-justify">
                      Saat Anda menggunakan layanan elektronik Kami,
                      berinteraksi dengan Kami, dan/atau menggunakan layanan di
                      situs web Kami. Hal ini termasuk tanpa batasan melalui
                      cookie yang Kami terapkan saat Anda berinteraksi dengan
                      situs web Kami;
                    </li>
                    <li className="text-justify">
                      Saat Anda melakukan transaksi melalui layanan Kami;
                    </li>
                    <li className="text-justify">
                      Saat Anda memberikan umpan balik atau keluhan kepada kami;
                    </li>
                    <li className="text-justify">
                      Saat Anda mendaftar untuk suatu program; atau
                    </li>
                    <li className="text-justify">
                      Saat Anda mengirimkan data pribadi Anda kepada Kami dengan
                      alasan apa pun.
                    </li>
                  </ol>
                </ol>
                <p className="mt-2 text-sm lg:text-xl">
                  Hal-hal di atas tidak dimaksudkan atau ditetapkan sebagai
                  daftar lengkap atau contoh umum tentang kapan data pribadi
                  tentang Anda akan dikumpulkan
                </p>
              </li>
            </ol>
          </div>
        </div>

        <div className="flex flex-col items-center justify-center gap-2 py-8">
          <p className="font-nunito font-bold text-xl lg:text-2xl">Kebijakan Pengembalian Dana</p>
          <div className="flex py-5 text-left font-nunito font-semibold lg:font-normal">
            <ol className="flex flex-col text-sm lg:text-lg">
              <li className="flex flex-col gap-1 text-left">
                <p>Permohonan Pengembalian Dana</p>
                <p>
                  Tunduk pada syarat dan ketentuan dalam Kebijakan Pengembalian
                  Dana. Pembeli dapat mengajukan pengembalian dana, lalu akan
                  dilakukan peninjauan untuk diputuskan apakah permohonan dapat
                  disetujui.
                </p>
              </li>
              <li className="flex flex-col gap-1 text-left">
                <p>Hak Penjual</p>
                <p>
                  Ketika Wardaya College (“Penjual”) menerima permohonan dari
                  Pembeli untuk melakukan pengembalian dana, Wardaya College
                  akan meninjau setiap permohonan untuk menentukan apakah
                  permohonan Pembeli dapat disetujui. Wardaya College akan
                  menghubungi Pembeli melalui platform WhatsApp dan memberi
                  keputusan terkait pengembalian dana.{" "}
                </p>
              </li>
              <li className="flex flex-col gap-1 text-left">
                <p>Kondisi Pengembalian Dana</p>
                <p>
                  Pembeli harus memastikan bahwa kelas yang dibeli tersebut
                  belum dimulai dan/atau sudah berjalan minimal satu kali
                  pertemuan agar proses pengembalian dana dapat dilakukan lebih
                  mudah. Pembeli juga perlu menyertakan foto bukti pembayaran
                  dan opsi pembayaran yang telah dipilih. Jika terjadi kesalahan
                  yang tidak terduga dari pihak Penjual, Penjual akan menanggung
                  pengembalian dana milik Pembeli. Jika Pembeli berubah pikiran
                  setelah melakukan pembelian, Pembeli harus mendapatkan
                  persetujuan terlebih dulu dari Wardaya College.
                </p>
              </li>
              <li className="flex flex-col gap-1 text-left">
                <p>Pengembalian Dana</p>
                <p>
                  Dana Pembeli hanya akan dikembalikan setelah Wardaya College
                  meninjau dan menerima setiap permohonan yang diajukan Pembeli.
                  Pengembalian dana akan dilakukan ke nomor rekening yang
                  dimiliki Pembeli. Pengembalian dana yang akan diberikan
                  sebesar 75% dari harga kelas, baik ketika kelas belum dimulai
                  atau sudah berjalan. Jika kelas sudah berjalan, maka dana yang
                  akan dikembalikan, yaitu sebesar 75% dari sesi pertemuan yang
                  belum diikuti.
                </p>
              </li>
              <li className="flex flex-col gap-1 text-left">
                <p>Syarat dan Ketentuan</p>
                <p>
                  Pembeli harus mengirimkan bukti dan opsi pembayaran yang
                  dilakukan.
                </p>
              </li>
            </ol>
          </div>
        </div>

        <div className="flex flex-col items-center justify-center gap-2 py-8">
          <p className="font-nunito font-bold text-xl lg:text-2xl">Syarat dan Ketentuan</p>
          <div className="flex flex-col gap-6 py-5 text-left font-nunito font-semibold lg:font-normal">
            <ol className="flex flex-col gap-5 text-sm lg:text-lg">
              <li>
                <p>Pendahuluan</p>
                <ol>
                  <li className="text-justify">
                    Selamat datang di Program Platform Wardaya Online
                    (“Program”). Program ini adalah layanan tambahan yang
                    disediakan oleh Wardaya College di mana Wardaya College
                    mencantumkan produk untuk dijual di atau melalui situs web
                    wardayaonline.com. Ketentuan Layanan Platform Wardaya Online
                    ini dimaksudkan untuk mencakup aktivitas yang disediakan
                    oleh Wardaya College kepada pengguna termasuk, namun tidak
                    terbatas pada, mengumpulkan, mendamaikan dan melaksanakan
                    semua transaksi antara Wardaya College dan pengguna. Jika
                    Anda adalah pengguna Wardaya Online, Anda akan dianggap
                    telah menyetujui syarat dan ketentuan Persyaratan Layanan
                    Platform Wardaya Online dan Kebijakan Wardaya Online
                    lainnya, di mana Persyaratan Layanan Platform Wardaya Online
                    ini menjadi bagiannya, dengan partisipasi Anda yang
                    berkelanjutan. Ketentuan Layanan Platform Wardaya Online ini
                    melengkapi Ketentuan Layanan dan Kebijakan Wardaya Online
                    lainnya - harap baca Ketentuan Layanan dan Kebijakan Wardaya
                    Online lainnya yang tersedia di Situs karena memuat
                    informasi penting mengenai hak dan kewajiban Anda. Setiap
                    istilah yang digunakan dalam Ketentuan Layanan Platform
                    Wardaya Online yang tidak didefinisikan di sini akan
                    memiliki arti yang diberikan untuk istilah tersebut dalam
                    Ketentuan Layanan dan / atau Kebijakan Wardaya Online yang
                    berlaku. Semua syarat dan ketentuan yang dijelaskan dalam
                    Ketentuan Layanan Platform Wardaya Online ini dapat berubah
                    atas kebijakan Wardaya Online sesuai dengan Ketentuan
                    Layanan.
                  </li>
                  <li className="text-justify">
                    Wardaya College berhak untuk mengubah, memodifikasi,
                    menangguhkan, atau menghentikan semua atau sebagian dari
                    Program ini kapan saja atau dengan pemberitahuan seperti
                    yang dipersyaratkan oleh hukum setempat. Wardaya College
                    dapat merilis layanan tertentu dari Program atau
                    fitur-fiturnya dalam versi beta, yang mungkin tidak
                    berfungsi dengan benar atau dengan cara yang sama seperti
                    versi final, dan kami tidak akan bertanggung jawab dalam hal
                    tersebut. Wardaya College juga dapat membatasi fitur
                    tertentu atau membatasi akses Anda ke sebagian, atau
                    keseluruhan, Program atas kebijakannya sendiri dan tanpa
                    pemberitahuan atau kewajiban.
                  </li>
                  <li className="text-justify">
                    Jika Anda ingin keluar dari Program, Anda harus menulis ke
                    sekretariat@wardayacollege.com. Setelah kami menerima email
                    atau panggilan Anda, kami akan melanjutkan untuk menghapus
                    listing Anda dari Situs Wardaya Online. Harap dicatat bahwa
                    diperlukan waktu hingga 2 hari untuk menghapus semua listing
                    Anda dari Situs Wardaya Online dan Anda harus terus memenuhi
                    pesanan yang dibuat selama periode ini.
                  </li>
                  <li className="text-justify">
                    Jika terjadi perbedaan antara ketentuan dalam Kebijakan
                    Wardaya College dan Ketentuan Layanan Platform Wardaya
                    Online ini, Ketentuan Layanan Platform Wardaya Online ini
                    akan terus berlaku.
                  </li>
                </ol>
              </li>
            </ol>
          </div>
        </div>
      </div>

      <style jsx>
        {`
          ol {
            list-style-type: none;
            counter-reset: item;
            margin: 0;
            padding: 0;
          }

          ol > li {
            display: table;
            counter-increment: item;
            margin-bottom: 0.6em;
          }

          ol > li:before {
            content: counters(item, ".") ". ";
            display: table-cell;
            padding-right: 0.5em;
          }

          li ol > li {
            margin: 0;
          }

          li ol > li:before {
            content: counters(item, ".") " ";
          }
        `}
      </style>
    </div>
  );
}
